import { useMedplumProfile } from "@medplum/react";

import NotFound from "@/NotFound";

interface PractitionerContainerProps {
  children: React.ReactNode;
}

export default function PractitionerContainer({ children }: PractitionerContainerProps) {
  const profile = useMedplumProfile();

  if (!profile?.id || profile?.resourceType !== "Practitioner") {
    return <NotFound />;
  }

  return children;
}
